<template>
  <div>
    <booking-report-base-component :available-columns="availableColumns" type="passenger" :extended-filters="true" />
  </div>
</template>

<script>
import allAvailableColumns from "../../../staticData/BookingReportAvailableColumns";
import BookingReportBaseComponent from "../../../components/Booking/Report/BookingReportBaseComponent";

export default {
  name: "BookingReportPassengerView",
  components: {
    BookingReportBaseComponent
  },
  computed: {
    availableColumns() {
      let columnSelectValue = [
        "name",
        "creation_date",
        "reservation_number",
        "route",
        "ticket_number",
        "passengers",
        "count",
        "discount",
        "netSummary",
        "grossSummary",
        "grossSummaryWithDiscount",
        "averageTicketPrice",
        "airportCharges",
        "fareBase",
        "low_fare",
        "lostBenefit",
        "lostBenefitPercentage",
        "organization_unit",
        "compartment",
        "airline_name",
        "airline_iata",
        "airline_icao",
        "invoice_number",
        "issue_date"
      ];
      return allAvailableColumns().filter(v => columnSelectValue.includes(v.selectValue));
    }
  }
};
</script>
